import { TransactionTypeEnum } from "../enums/TransactionTypeEnum";

export class Integration {
    name: string;
    createDateTime: Date;

    static parse(data: any): Integration {
        var res = new Integration();
        res.name = data.Name;
        res.createDateTime = new Date(data.CreateDateTime);
        return res;
    }
}
